import { useEffect, Fragment } from 'react';
import { Navigate, Route, useLocation, useNavigate } from 'react-router-dom';
import { getToken } from '../config/axios.config';
import { getAuthUser } from '../utils/auth.util';
import { SpinnerLoading } from '../components/Common';

function AuthProtected({ children }) {
  const userProfile = getAuthUser();
  const token = getToken;
  const authUser = getAuthUser();
  const location = useLocation();
  const navigate = useNavigate();

  // Handle authentication and redirection logic
  useEffect(() => {
    const bypassUrls = [
      '/login',
      '/reset-password',
      '/logout',
      '/forget-password',
    ];
    if (
      !bypassUrls.includes(location?.pathname) &&
      !authUser?.id &&
      location.pathname !== '/login'
    ) {
      navigate('/login');
    }
  }, [authUser, location, navigate]);

  if (!authUser?.id) {
    return <SpinnerLoading spinnerSize="4rem" height="85vh" color="#405189" />;
  }

  // Handle unauthenticated access
  if (!userProfile && !token) {
    return <Navigate to={{ pathname: '/login', state: { from: location } }} />;
  }

  //  Render protected children
  return <Fragment key={location.key}>{children}</Fragment>;
}

/**
 * @description Wrapper for protected routes.
 */
function AccessRoute({ component: Component, ...rest }) {
  return (
    <Route
      path={rest.path}
      exact={rest.exact}
      sensitive={rest.sensitive}
      element={<Component />}
    />
  );
}

export { AuthProtected, AccessRoute };
